import Reveal from '@/components/base/Reveal';
import MelonCard from '@/pages/home/components/MelonCard';
import { todayMelons } from '@/mocks/homeData';

export default function TodayMelons() {
  const featured = todayMelons.find((item) => item.size === 'large');
  const rest = todayMelons.filter((item) => item.size !== 'large');

  return (
    <section id="today" className="bg-background-50">
      <div className="mx-auto w-full max-w-shell px-4 py-20 md:px-6 md:py-28">
        <Reveal>
          <div className="flex flex-col gap-6 border-b border-background-200/80 pb-10 md:flex-row md:items-end md:justify-between">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
                <i className="ri-fire-line" />
                今日新瓜
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
                大话题和小线索摆在一起，先看重点再看细节
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                热点区把今天最值得跟的内容按重要程度排开：头条用大卡铺开讲清楚，其余线索用小卡并排摆好，
                一次扫完，不用来回翻入口。
              </p>
            </div>
            <a
              href="#rolling"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/80 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              看全部滚动爆料
              <i className="ri-arrow-right-line text-base" />
            </a>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:grid-rows-2">
            {featured && <MelonCard item={featured} featured />}
            {rest.map((item) => (
              <MelonCard key={item.id} item={item} />
            ))}
          </div>
        </Reveal>

        <Reveal delay={160}>
          <div className="mt-8 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1.5">
              <span className="animate-live-dot h-1.5 w-1.5 rounded-full bg-secondary-500" />
              编辑组每 7 分钟复核一次热点区
            </span>
            <span className="hidden sm:inline">·</span>
            <span>已确认来源 12 条，待复核 3 条</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}